import React, { Fragment } from 'react';

export default class Loader extends React.Component {

    renderInPage() {
        if (!this.props.inPage) {
            return null;
        }
        return (
            <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        )
    }

    renderFullPageLoader() {
        if (this.props.inPage) {
            return null;
        }
        return (
            <section className="qloader active">
                <div className="loader-circle"></div>
                <div className="loader-line-mask">
                    <div className="loader-line"></div>
                </div>
            </section>
        )
    }

    render() {
        if (!this.props.show) {
            return null;
        }
        return (
            <Fragment>
                {this.renderFullPageLoader()}
                {this.renderInPage()}
            </Fragment>
        )
    }
}